/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AnalyticTable from 'components/kea/tables/AnalyticTable';
import CardContainer from 'components/kea/CardContainer';
import { getConversionBest } from 'actions';
import { linkToProductDetail } from 'util/appUtils';
import { useLocalizedMessage } from 'util/useLocalizedMessage';
import cardStyles from '../../StoreAnalyticsCards.module.scss';

const BestConversion = () => {
  const dispatch = useDispatch();
  const localizeMessage = useLocalizedMessage();
  const { analytics: { products, timeframe }, app: { currentShop } } = useSelector((str) => str);
  const { conversionBest: { isFetching, data, error } } = products;

  useEffect(() => {
    dispatch(getConversionBest(currentShop, timeframe));
  }, [timeframe]);

  const headCells = [
    {
      id: 'name',
      numeric: false,
      label: localizeMessage('analytics.table.productName'),
      sortKey: 'nameText',
    },
    { id: 'views', numeric: true, label: localizeMessage('analytics.table.views') },
    { id: 'purchases', numeric: true, label: localizeMessage('analytics.table.purchases') },
    { id: 'conversion', numeric: true, label: localizeMessage('analytics.table.conversion') },
  ];

  const prepareRows = (rows) => rows.map((e) => ({
    ...e,
    nameText: e.name,
    name: linkToProductDetail(currentShop, e.name, e.id),
    conversion: e.conversion,
  }));

  return (
    <CardContainer
      headerId="search.analytics.conversion.best.header"
      styleName={`noMargin ${cardStyles.card} ${cardStyles.bestConversion}`}
      tableSurface
      isFetching={isFetching}
      error={error}
    >
      <AnalyticTable
        rows={prepareRows(data)}
        headCells={headCells}
        orderById="conversion"
        emptyMessageId="analytics.empty.conversion"
      />
    </CardContainer>

  );
};

export default BestConversion;
